<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"/>

    <!-- 점검대상 -->
<!--    <div class="mt-5">-->
<!--      <vs-row class="mt-6">-->
<!--        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
<!--          <h5><i class="dot"></i>{{ $t('점검대상') }}</h5>-->
<!--        </vs-col>-->
<!--      </vs-row>-->

<!--      <div class="gap-x-6 gap-y-4 mt-4">-->
<!--        <span v-if="isPrint"> {{ form.inspectionTitle }} </span>-->
<!--        <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
<!--          <vs-checkbox-->
<!--            v-model="form.inputB_1"-->
<!--            class="mr-1 mb-2"-->
<!--            :readonly="board.readonly"-->
<!--          >-->
<!--            {{form.inspectionTitle}}-->
<!--          </vs-checkbox>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <!-- 도급전 정보 제공 -->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!-- 기타 특이사항 -->
    <div class="mt-5">
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('기타 특이사항') }}</h5>
        </vs-col>
      </vs-row>
      <div class="col-span-12 flex items-start mt-4">
        <span  v-if="isPrint" class="textarea"> {{ form.inputC_1 }} </span>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputC_1"
          :readonly="board.readonly"
        />
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :readonly="board.readonly"
      :is-print="isPrint"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import TableInspect from '@/components/TableInspect'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (/*value*/) {
        this.form.inputA_2 = this.value && this.value.inputA_2 ? this.value.inputA_2 : this.board.projectTitle
      },
    },
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.title = value.inputA_2
        this.$emit('input', value)
      },
    },
  },
  data () {
    return {
      inspectionTitle:'도급전 정보 제공',
      form: {
        inspectionTitle:'도급전 정보 제공',

        stdInfo: {},

        inputB_1: false,

        inputC_1: '',

        inputD_1: {},

        fileList: [],
        inspectList: [],
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '위험성평가 결과 정보를 제공하였는가?',
          is_checked: '',
        },
        {
          id: 2,
          label: '작업환경 측정 결과 정보를 제공하였는가?',
          is_checked: '',
        },
        {
          id: 3,
          label: '도급인 안전 및 정보를 제공하였는가?',
          is_checked: '',
        },
        {
          id: 4,
          label: '유해·위험요인 정보를 제공하였는가?',
          is_checked: '',
        },
        {
          id: 5,
          label: '기타 안전보건 관련 자료를 제공하였는가?',
          is_checked: '',
        },
      ]
    },
  },
  methods: {
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 110px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 16px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
